import styled from 'styled-components';

interface CardProps {
  isSmall?: boolean;

}
interface ImageWrapperProps {
  isVertical?: boolean;
  isMicro?: boolean;
  isSpecialOffer?: boolean;
}
interface CardStyles {
  isMicro?: boolean;
}
export const CardWrapper = styled.div<CardProps>`
  background-color: #F4F4F5;
  border-radius: 15px;
  overflow: hidden;
  width: 100%;
  ${({ isSmall }) => isSmall && 'max-width: 300px;'}
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-shrink: 0;
  cursor: pointer;
  padding: 12px;
`;

export const ImageWrapper = styled.div<ImageWrapperProps>`
  width: 100%; 
  ${({ isVertical }) => (isVertical ? 'height: 360px;' : 'height: 180px;')}
  ${({ isMicro }) => (isMicro ? 'height:auto;' : '  height:175px;')}
  ${({ isSpecialOffer }) => (isSpecialOffer && 'height:221px;')}
  position: relative;
  overflow: hidden;
  width: 100%;
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;
  ${({ isMicro }) => (isMicro && ' padding-top:0;')}

`;

export const Image = styled.img<CardStyles>`
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 10px;

  ${({ isMicro }) => (isMicro ? 'position: relative' : 'position: absolute;')}

  ${({ isMicro }) => (isMicro ? 'border:solid red;' : 'position: absolute;')}

`;

export const Logo = styled.img`
  position: absolute;
  left: 12px;
  bottom: 12px;
  width: 60px;
  height: 60px;
  border-radius: 10px;
  object-fit: cover;
  border-radius: 10px;
`;

export const FreeAccess = styled.span`
  position: absolute;
  left: 12px;
  top: 12px;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.2;
  font-weight: 600;
  color: #FFF;
  background: rgb(26, 93, 13);
`;

export const FreePlaces = styled.span`
  position: absolute;
  left: 12px;
  top: 12px;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.2;
  font-weight: 600;
  color: #FFF;
  background: #1C1C1C;
`;

export const Info = styled.span`
  border-radius: 5px;
  position: absolute;
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(8px);
  bottom: 8px;
  left: 15px;
  width: 126px;
  border: 1px solid #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  font-size: 10px;
  line-height: 1.2;
  font-weight: 700;
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%; 
  padding: 12px 0 0 0;
  gap: 12px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  flex: 1;
  gap: 4px;
`;

export const Title = styled.span`
  font-size: 14px;
  line-height: 1.4;
  font-weight: 500;
  color: #1C1C1C;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* Limit text to 2 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Description = styled.span`
  font-size: 12px;
  line-height: 1.4;
  font-weight: 400;
  color: #52525B;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Limit text to 2 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
`;

export const PriceLabel = styled.div`
  position: absolute;
  left: 12px;
  bottom: 12px;
  padding: 5px 15px;
  border-radius: 10px;
  background: rgba(0,0,0,0.9);
  object-fit: cover; 
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #FFF;
`;

export const PriceLabelText = styled.span`
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  color: #FFF;
  white-space: nowrap;
  overflow: hidden;
`;

export const RedLabelContainer = styled.div`
  background:rgb(208, 56, 56);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 10px;
`;

export const RedLabelText = styled.span`
  font-size: 12px;
  line-height: 1.2;
  font-weight: 500;
  color: #FFF;
  white-space: nowrap;
  overflow: hidden;
`;

export const TimeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const Time = styled.span`
  font-size: 12px;
  line-height: 1.2;
  font-weight: 400;
  color: #757575;
  white-space: nowrap;
  overflow: hidden;
`;

export const Button = styled.div`
  margin-left: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 5px;
  background: #FFF;
`;
